import { Group, type GroupProps } from "@mantine/core"
import type { PropsWithChildren } from "react"
import { Tag } from "./Tag"

export function Tags({ tags, children, ...props }: PropsWithChildren<{ tags?: string[] } & GroupProps>) {
  return (
    <Group gap="xs" {...props}>
      {children}
      {tags?.map((tag) => (
        <Tag key={tag} id={tag} />
      ))}
    </Group>
  )
}
